import { __rest } from 'tslib';
import { jsx } from 'react/jsx-runtime';
import { styled } from '@mui/material';
import { components } from 'react-select';
import { ReactComponent as ForwardRef } from '../../../assets/icons/ArrowDownSmall.svg.js';
import 'react';

const ArrowIcon = styled(ForwardRef) `
  ${({ theme, open }) => open &&
    `
    transform: rotate(180deg);
    color: ${theme.palette.primary.main}
  `}
`;
const DropdownIndicator = (_a) => {
    var { selectProps } = _a, rest = __rest(_a, ["selectProps"]);
    return (jsx(components.DropdownIndicator, Object.assign({ selectProps: selectProps }, rest, { children: jsx(ArrowIcon, { open: selectProps.menuIsOpen }) })));
};

export { DropdownIndicator as default };
//# sourceMappingURL=DropdownIndicator.js.map
